<template>
  <Header12 />
  <div class="body">
    <section class="background-bleu">
      <MenuTitle title="Conduite du changement" subTitle="" srcImg="/images/pages/image-title-menu.jpg"
        backgroundSpan="span-background-blue" />
    </section>
    <section>
      <NavLeft tab="conduite_du_changement" breadcrumb1="" breadcrumb2="Conduite du changement" />
    </section>
    <section class="background-bleu">
      <Expertises />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Expertises from '@/components/emci/Homepage/Nos-expertises/index.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
useHead({
  title: "EMCI - La conduite du changement en entreprise.",
  meta: [
    {
      name: "description",
      content: "Élément déterminant pour une entreprise, la conduite du changement est au cœur de nos métiers aujourd’hui. Le cabinet EMCI vous propose d’accompagner ces moments de transition."
    }
  ]
})
</script>

<style scoped>
.body {
  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }

  .background-bleu {
    margin-bottom: 50px;
  }
}
</style>